import * as React from 'react';

export function useClickWithFeedback(onClick: (e: React.MouseEvent<any, any>) => void) {

	// Mantengo los props estables con un useMemo para minimizar renders adicionales si hay objetos dentro
	// cuya referencia cambie (como el _active) o funciones. Así evito tener que ir metiendo useMemo o useCallback

	const props = React.useMemo(() => ({
		onClick: (e: React.MouseEvent) => {

			// TODO: Esto está bien, pero ahora mismo no todas las pantallas pasan por aquí,
			// porque tenemos las legacy que usan otros botones. ¿Es buena idea que sólo algunos
			// botones vibren? Diría que no, porque al final no es un feedback fiable.

			// navigator.vibrate([100]);

			onClick(e);
		},
		// Meto filter en transitionProperty porque hay botones que lo usan, y me sale mejor meterlo aquí
		// que diseñar un API que permita pasarle a esta función cosas adicionales y andar mergeando props
		transitionProperty: 'filter, transform',
		transitionDuration: '0.05s',
		_active: {
			transform: 'scale(0.97)'
		}
	}), [onClick]);

	return props;
}